var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLocationPinSolidStation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: 384,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "location-pin-solid-station") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #1e3050 } \n\t\t.s1 { fill: #ffffff } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m384 192c0 87.4-117 243-168.3 307.2-12.3 15.3-35.1 15.3-47.4 0-51.3-64.2-168.3-219.8-168.3-307.2 0-106 86-192 192-192 106 0 192 86 192 192z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Layer 1",
    className: "s1",
    d: "m134.9 97.5c0-5.5 4.5-10 10-10h94.7c5.6 0 10 4.5 10 10v288.8c0 5.5-4.4 10-10 10h-94.7c-5.5 0-10-4.5-10-10z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Layer 4",
    className: "s1",
    d: "m128 81c0-16.6 13.4-30 30-30h67.3c16.6 0 30 13.4 30 30v67.3c0 16.6-13.4 30-30 30h-67.3c-16.6 0-30-13.4-30-30z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Layer 2",
    className: "s0",
    d: "m152.4 83.2c0-5.6 4.5-10 10-10h58.9c5.5 0 10 4.4 10 10v58.8c0 5.5-4.5 10-10 10h-58.9c-5.5 0-10-4.5-10-10z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Shape 1",
    className: "s0",
    d: "m186.3 177.7c0-1.2 0.9-2 2-2h7.8c1.1 0 2 0.8 2 2v7.8c0 1.1-0.9 2-2 2h-7.8c-1.1 0-2-0.9-2-2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Shape 1 copy",
    className: "s0",
    d: "m208.6 177.7c0-1.2 0.9-2 2-2h7.8c1.1 0 2 0.8 2 2v7.8c0 1.1-0.9 2-2 2h-7.8c-1.1 0-2-0.9-2-2z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Shape 1 copy 2",
    className: "s0",
    d: "m163.9 177.7c0-1.2 0.9-2 2-2h7.9c1.1 0 2 0.8 2 2v7.8c0 1.1-0.9 2-2 2h-7.9c-1.1 0-2-0.9-2-2z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Shape 1 copy 3",
    className: "s0",
    d: "m186.3 198.7c0-1.1 0.9-2 2-2h7.8c1.1 0 2 0.9 2 2v7.8c0 1.1-0.9 2-2 2h-7.8c-1.1 0-2-0.9-2-2z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Shape 1 copy 4",
    className: "s0",
    d: "m208.6 198.7c0-1.1 0.9-2 2-2h7.8c1.1 0 2 0.9 2 2v7.8c0 1.1-0.9 2-2 2h-7.8c-1.1 0-2-0.9-2-2z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Shape 1 copy 5",
    className: "s0",
    d: "m163.9 198.7c0-1.1 0.9-2 2-2h7.9c1.1 0 2 0.9 2 2v7.8c0 1.1-0.9 2-2 2h-7.9c-1.1 0-2-0.9-2-2z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Shape 1 copy 6",
    className: "s0",
    d: "m186.3 219.7c0-1.1 0.9-2 2-2h7.8c1.1 0 2 0.9 2 2v7.8c0 1.1-0.9 2-2 2h-7.8c-1.1 0-2-0.9-2-2z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Shape 1 copy 7",
    className: "s0",
    d: "m208.6 219.7c0-1.1 0.9-2 2-2h7.8c1.1 0 2 0.9 2 2v7.8c0 1.1-0.9 2-2 2h-7.8c-1.1 0-2-0.9-2-2z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Shape 1 copy 8",
    className: "s0",
    d: "m163.9 219.7c0-1.1 0.9-2 2-2h7.9c1.1 0 2 0.9 2 2v7.8c0 1.1-0.9 2-2 2h-7.9c-1.1 0-2-0.9-2-2z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPinSolidStation);
export default __webpack_public_path__ + "static/media/location-pin-solid-station.8eae0c7cbda786fe73fe818e1010d262.svg";
export { ForwardRef as ReactComponent };